import { Transactions as Constants } from "../constants";
import { transactionApi as api } from "../../api";

export const transactionAction = {
  get,
};

function get() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._get().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.TRANSACTIONS_SUCCESS, payload };
  }
  function failure(error) {
    return { type: Constants.TRANSACTIONS_FAILED, error };
  }
}
